/**
 * Created by andrey on 21.12.2021.
 */

const GameDataSaver = function (key) {
    this.key = key;
};

GameDataSaver.prototype.save = function (data) {
    const current = cleverapps.dataLoader.load(DataLoader.TYPES.GAME_DATA) || {};
    current[this.key] = data;
    cleverapps.dataLoader.save(DataLoader.TYPES.GAME_DATA, current);
};

GameDataSaver.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.GAME_DATA);
    return data && data[this.key];
};

GameDataSaver.prototype.add = function (data) {
    let current = this.load() || {};
    current = { ...current, ...data };
    this.save(current);
};

GameDataSaver.prototype.clear = function () {
    this.save();
};

GameDataSaver.prototype.loadAndClear = function () {
    const data = this.load();
    if (data) {
        this.clear();
    }
    return data;
};

GameDataSaver.Reset = function () {
    cleverapps.dataLoader.remove(DataLoader.TYPES.GAME_DATA);
};

GameDataSaver.Create = function (key) {
    const slotId = typeof Game !== "undefined" && Game.currentGame && Game.currentGame.slotId
        || typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation && Map2dLocation.currentLocation.location.slot.slotId
        || Meta.SLOT_MAIN;
    return new GameDataSaver(key + slotId);
};